/**
 * @file: customIssueToReportItem.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { OptionValueType } from '@euler/model/enum';
import {
  InspectionReportItem,
  InspectionReportItemType,
  MediaInfo,
  MediaSourceType,
} from '@euler/model/report';
import { CustomIssue } from '@euler/model/task-detail';

export const customIssueToReportItem = (params: {
  customIssue: CustomIssue;
}): InspectionReportItem => {
  const { customIssue } = params;

  return {
    type: InspectionReportItemType.Normal,
    label: customIssue.label,
    inspectionType: customIssue.inspectionType,
    siteId: customIssue.siteId,
    siteName: customIssue.siteName,
    siteInfluenceFactor: 0,
    siteItemInfluenceFactor: 0,
    siteItemId: customIssue.itemId,
    siteItemName: customIssue.itemName,
    referenceState: customIssue.referenceState,
    abnormalLevel: customIssue.abnormalLevel,
    severityLevel: customIssue.severityLevel,
    maintenanceAdvice: customIssue.maintenanceAdvice,
    resultDataType: OptionValueType.String,
    resultDataStringValue: customIssue.inspectionResult,
    resultRemark: customIssue.description,
    normalValueType: OptionValueType.String,
    abnormalResultLabel: customIssue.inspectionResult,
    abnormalDescription: customIssue.description,
    data: [],
    medias: customIssue.medias.map<MediaInfo>(x => ({
      id: x.cid,
      type: x.type,
      sourceType: MediaSourceType.CustomIssue,
      category: '',
      title: x.title,
      subTitle: x.subTitle,
      url: x.url,
      coverUrl: x.coverUrl,
      dateRef: new Date(x.dateRef!),
      remark: x.remark,
      annotationMetadata: x.annotationMetadata,
    })),
  };
};
